const roleUsersActionTypes =  {    
    RETRIEVED_SUGGEST_LIST: "RETRIEVED_SUGGEST_LIST",
    RETRIEVED_USERS_LIST: "RETRIEVED_USERS_LIST",
    ADD_USER_INTO_ROLE: "ADD_USER_INTO_ROLE",
    REMOVE_USER: "REMOVE_USER"
};
export default roleUsersActionTypes;
